import { FormikHelpers, FormikValues } from 'formik';
import React, { useState } from 'react';
import { useSearchParams } from 'react-router-dom';

import Buscando from 'Component/Admin/Buscando';
import Cabecalho from 'Component/Admin/Cabecalho';
import SemRegistros from 'Component/Admin/SemRegistros';
import { TarefaAdicionar, TarefaLista } from 'Component/Admin/Tarefa';
import Botao from 'Component/Botao';
import Form, { Campo, Selecao } from 'Component/Form';
import Paginacao from 'Component/Paginacao';
import { useRecuperarUsuariosQuery } from 'Service';
import { useAppSelector } from 'Store';
import { SIM_OU_NAO, TIPOS_DE_TAREFAS_FILTRO } from 'View/constants';
import { useRecuperarTarefasQuery } from 'View/Service/Default/Tarefas';

const Default = (): React.ReactElement => {
  const usuario = useAppSelector((estado) => estado.autenticacao.usuario);
  const [minhas, setMinhas] = useState<boolean>(true);
  const [exibir, setExibir] = useState<boolean>(false);
  const [searchParams, setSearchParams] = useSearchParams();

  const {
    data: { tarefas, paginacao } = {},
    refetch,
    isFetching,
    isLoading,
  } = useRecuperarTarefasQuery({
    contain: ['Proprietarios', 'Atendentes'],
    page: searchParams.get('pagina') || 1,
    options: {
      busca: { termo: searchParams.get('busca') || '' },
      tipo: searchParams.get('tipo') || '',
      validado: searchParams.get('validado') || '',
      atendente_id: searchParams.get('atendente_id') || '',
    },
    sort: 'Tarefas.modificado',
    direction: 'desc',
    scope: minhas,
  });

  const { data: { usuarios } = {}, refetch: refetchUsuarios } =
    useRecuperarUsuariosQuery({
      finder: 'listaJson',
      options: { permissao: ['super', 'admin', 'conteudista'] },
      limit: 500,
      sort: 'nome',
    });

  const filtrar = (
    dados: { [chave: string]: string },
    form: FormikHelpers<FormikValues>
  ) => {
    for (const filtro in dados) {
      if (dados[filtro] !== '') {
        searchParams.set(filtro, dados[filtro]);
      } else {
        searchParams.delete(filtro);
      }
    }

    searchParams.set('pagina', '1');
    setSearchParams(searchParams);

    form.setSubmitting(false);
  };

  return (
    <div className="animate__animated animate__fadeIn">
      <Cabecalho
        titulo="Tarefas"
        descricao="Listagem de tarefas criadas ou atribuídas à você"
      />
      <Form
        emLinha
        onSubmit={filtrar}
        desabilitado={isFetching}
        inicial={{ busca: searchParams.get('busca') || '' }}
      >
        <div className="row">
          <div className="col-md-4 mb-3 d-flex gap-2">
            <Botao
              icone="arrow-clockwise"
              onClick={() => {
                refetch();
                refetchUsuarios();
              }}
            />
            {usuario && ['super', 'admin'].includes(usuario.permissao) && (
              <>
                <Botao
                  tema="success"
                  icone="plus-lg"
                  onClick={() => setExibir(true)}
                >
                  Adicionar
                </Botao>
                <div className="btn-group">
                  <Botao
                    texto="Minhas"
                    className={minhas ? 'active' : ''}
                    onClick={() => setMinhas(true)}
                  />
                  <Botao
                    texto="Todas"
                    className={!minhas ? 'active' : ''}
                    onClick={() => setMinhas(false)}
                  />
                </div>
              </>
            )}
          </div>
          <div className="col-md-8 mb-3">
            <div className="hstack gap-3">
              <Selecao
                name="atendente_id"
                padrao="Atendente"
                opcoes={usuarios}
              />
              <Selecao
                name="tipo"
                padrao="Tipo da tarefa"
                opcoes={TIPOS_DE_TAREFAS_FILTRO}
              />
              <Selecao name="validado" padrao="Validado" opcoes={SIM_OU_NAO} />
              <Campo name="busca" rotulo="Buscar..." />
              <Botao type="submit" icone="filter" />
            </div>
          </div>
        </div>
      </Form>
      <Buscando exibir={isLoading} />
      <SemRegistros carregando={isLoading} registros={tarefas?.length} />
      <div className="bg-white shadow-sm rounded">
        {tarefas?.map((tarefa) => (
          <TarefaLista
            key={`${tarefa.id}-${tarefa.modificado}`}
            dados={tarefa}
          />
        ))}
      </div>
      <Paginacao dados={paginacao} desabilitado={isFetching} />
      <TarefaAdicionar exibir={exibir} aoFechar={setExibir} />
    </div>
  );
};

export default Default;
